export const remove: any = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M13.5359 6.46489L6.46484 13.536M13.5359 13.5359L6.46484 6.46484" stroke="#011224" stroke-width="2"
              strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)